<div class="page-heading mb-2" style="cursor: pointer; width: fit-content;" (click)="onBack()"><button mat-raised-button><mat-icon>arrow_back</mat-icon>Back to all jobs</button></div>

<app-mwe-table [columns]="columns" [data]="data" [title]="'All Applications'" [showAddButton]="false"
    [showFilter]="false" [showSearch]="true" (selectedAction)="selectedAction($event)">
</app-mwe-table>

<!-- <h2 *ngIf="showNoRecordsFounds" class="no-records">No records found</h2> -->
<div *ngIf="showNoRecordsFounds"  class="no-results">
    <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
    <div class="no-records-found"> No Job Applications Found </div>
  </div>